import React, { useRef } from 'react'
import { graphql } from 'gatsby'
import scrollToComponent from 'react-scroll-to-component'
import styled from 'styled-components'

import TextSection from '../components/TextSection'
import EventCalendar from '../components/event/EventCalendar'
import Background from '../components/Background'
import Social from '../components/Social'
import HomepageHeader from '../components/homepage/HomepageHeader'
import Jobs from '../components/Jobs'

import { device, headerHeight } from '../styles/config'

const Container = styled.div`
  transform: translate3d(0,-${ headerHeight.desktop },0);

  @media ${ device.sm } {
    transform: translate3d(0,-${ headerHeight.mobile },0);
  }
`

const TextSections = styled.div`
  display: grid;
  row-gap: 10rem;
`

const CulturePage = ({
  data: {
    datoCmsKidsPage: {
      textSections,
      eventsTitle,
      eventsSubtitle,
      eventsText
    }
  }
}) => {
  return (
    <Container>
      <Background>
        <TextSection header={eventsTitle} name={eventsSubtitle} text={eventsText} />
        <EventCalendar kids/>
        <TextSections>
          {textSections.map((section, index) => (
            <TextSection
              key={index}
              header={section.title}
              name={section.subtitle}
              text={section.text}
            />
          ))}
        </TextSections>
        <Social />

      </Background>

    </Container>
  )
}

export const query = graphql`
  query KidsPage {
    datoCmsKidsPage {
      eventsTitle
      eventsSubtitle
      eventsText  
      textSections {
        title
        subtitle
        text
      }
    }
  }
`

export default CulturePage
